import script from "./OkrElementsTableCellPlug.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrElementsTableCellPlug.vue?vue&type=script&setup=true&lang=js"

import "./OkrElementsTableCellPlug.vue?vue&type=style&index=0&id=e944293c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e944293c"]])

export default __exports__